import { setLocalStorage } from "../../helper/localStorage";
import rememberTheNumberData from './mockData.json';

const createArray = (length, array = []) => {
  const newSet = new Set(array);
  while(newSet.size < length) {
    newSet.add(Math.floor(Math.random() * (99 - 10 + 1) + 10));
  }
  return [...newSet];
}

export const startRememberTheNumberTest = (
  test_id,
  gradeId,
  dispatchLaunchTest,
  dispatchHelper
) => {

  dispatchLaunchTest({
    type: "LOADER",
  });

  rememberTheNumberData.data[0].que = [];

  for (let i = 1; i <= 4; i++) {
    const questionArray = createArray(9);
    rememberTheNumberData.data[0].que.push({
      id: i,
      test_id: "190425225033",
      section_id: "60",
      choice_type: "",
      que_hint: "",
      que_title1: "Remember all digits seen below in given time",
      que_title1_type: "text",
      que_title2: createArray(20, questionArray).sort(() => Math.random() - 0.5),
      link1: "",
      link1_type: "",
      link2: "",
      link2_type: "",
      link1_ssml: "",
      link1_ssml_type: "",
      link2_ssml: "",
      link2_ssml_type: "audio",
      parent_quetitle: "",
      parent_link: "",
      parent_link_type: "",
      type_flag: "",
      grade: "2",
      difficulty_level: "1",
      choice_1: "",
      choice_2: "",
      choice_3: "",
      choice_4: "",
      choice_5: "",
      choice_6: "",
      correct_choice: "",
      correct_text: [...questionArray].toString(),
      resp_time: "20",
      active: "Y",
      created_date: "0000-00-00 00:00:00",
      created_by: "1",
      test_format: "remember_the_numbers",
      section_name: "REMEMBER THE NUMBERS",
      intro1:
        " Tapping before the stars appears will be considered negative. \n  <li>You have 20 attempts to record your fastest response time. </li>\n  <li>Total Test Duration – 4 minutes</li>\n  <li>Time to answer each question/attempt – 10 seconds</li>\n  <li>Respond as fast as you can</li>\n</ol>",
      intro2:
        "Your test will end if –<br>\n<ol>\n  <li>You minimize the app or go away from the test screen.</li>\n</ol>\n<br>",
      intro3:
        "Tap to start. Remember the position where the stars appears. Tap the corresponding boxes accurately and as quickly as possible.",
      info: "Tap to start. Remember the position where the star appears. Tap the corresponding boxes accurately and as quickly as possible.",
      info_audio: "remember_the_numbers",
      info_video: "remember_the_numbers_video",
      replay: "Y",
      score_rule: "Rule1",
      match_type: "exact",
      match_order: "Y",
      score_count: "single",
      match_hint: "N",
      custom_rule: "N",
      letter_count: "0",
    });
  }

  dispatchLaunchTest({ type: "RUNNING_TEST_DATA", payload: rememberTheNumberData });
  console.log(
    "%claunchtest!",
    "color:red;font-family:system-ui;font-size:2rem;font-weight:bold",
    rememberTheNumberData
  );
  const isCustomId = rememberTheNumberData.data[0].test_format === "tap_letter";
  const FNMix = rememberTheNumberData.data[0].test_format === "visual_facename_mix";

  const getTestId = () => {
    return isCustomId
      ? 1
      : FNMix
      ? "11862" // first id for FNMix test
      : rememberTheNumberData.data[0].que[0].id; // custom id for CPT test
  };
  dispatchHelper({
    type: "RUNNING_QUES_ID",
    payload: getTestId(),
  });
  setLocalStorage("RESERVE_TEST_DATA", rememberTheNumberData);

  dispatchLaunchTest({ type: "RESERVE_TEST_ID", payload: getTestId() });
};
